<!-- header while the user is not logined -->
<app-loader *ngIf="isButtonLoader" isAlertDialog="true"></app-loader>

<div>
  <div class="header" *ngIf="!isLoggedIn">
    <div class=" d_flex justify_space_bt">
      <img (click)="moveToWP()" [src]="companyInfo?.logo?.dark" alt="" class="header_logo">
      <div class="header_nav">
        <app-green-button-v2 label="Login" (click)="login()" width="100px"> </app-green-button-v2>
        <app-outlined-green-button (click)="signUp()" label="Sign Up" width="100px"></app-outlined-green-button>
      </div>

    </div>
  </div>

  <!-- header while the user is logined -->
  <div class="dashborad_header" *ngIf="isLoggedIn">
    <div class="left_side">
      <app-main-menu style="height: 100%;" class="sidbar" curActiveLink="Explore"></app-main-menu>
      <img class="header_logo" (click)="moveToWP()" [src]="companyInfo?.logo?.dark" alt="logo">

    </div>
    <div class="right_side">
      <app-light-green-button class="add_button" width="132px" height="45px" label="Sell My Home" (click)="addListing()"
        *ngIf="showSearch || historyState.hideContinue"></app-light-green-button>
      <div class="notification_icon">
        <img src="../../../assets/icons/notification_icon.svg" alt="">
      </div>
      <div class="user_details">
        <p class="user_name">
          {{ displayname }}
        </p>
        <div class="user_img center">
          <div class="user_image"></div>
        </div>
        <button mat-button [matMenuTriggerFor]="userMenu"><img src="../../../assets/icons/down_arrow_black.svg"
            alt=""></button>
        <mat-menu #userMenu="matMenu" xPosition="after">
          <button mat-menu-item (click)="myAccount()">My Account</button>
          <button mat-menu-item (click)="logOut()">Log Out</button>
        </mat-menu>
      </div>
    </div>
  </div>